// Page wrapper for the marketing admin dashboard. Register at /admin/marketing.
import MarketingDashboard from "../../../components/marketing/MarketingDashboard";

export default function MarketingPage() {
  return <MarketingDashboard />;
}
